export default {
  width: 22,
  height: 18,
  fill: true,
  svg: `
    <path fill-rule="evenodd" d="M20 10H2v6h18v-6zM2 8c-1.1046 0-2 .8954-2 2v6c0 1.1046.8954 2 2 2h18c1.1046 0 2-.8954 2-2v-6c0-1.1046-.8954-2-2-2H2zM4 2H2v2h2V2zM2 0C.8954 0 0 .8954 0 2v2c0 1.1046.8954 2 2 2h2c1.1046 0 2-.8954 2-2V2c0-1.1046-.8954-2-2-2H2zM12 2h-2v2h2V2zm-2-2C8.8954 0 8 .8954 8 2v2c0 1.1046.8954 2 2 2h2c1.1046 0 2-.8954 2-2V2c0-1.1046-.8954-2-2-2h-2zM20 2h-2v2h2V2zm-2-2c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h2c1.1046 0 2-.8954 2-2V2c0-1.1046-.8954-2-2-2h-2z" clip-rule="evenodd"/>
  `
}
